import { fetchData, apiURL } from './api_helper';

const setUserSettings = async (apiLevel, id, value) => {
  const data = {
    option: {
      [id]: value,
    },
  };
  const endPointURL = `${apiURL}${apiLevel}/users/settings/`;
  const { response } = await fetchData(endPointURL, 'post', data);
  return response;
  // TODO: mapping if needed --> async + await
};

const fetchAbTestOptions = async (apiLevel, cookieKey) => {
  const endPointURL = `${apiURL}${apiLevel}/users/visitor_classification?cookie_key=${cookieKey}&visitor_key=rfEZ5Etcf3DXcH52NkfprHABLmAQXCjtLFu9g7vkdTLvbYufWEaR2cgBCzU7KMtLUtY2aFtbsPPqxKC3qZpXFCJMNJw`;
  const { response } = await fetchData(endPointURL, 'get');
  return response;
};

const fetchUserSettings = async (apiLevel) => {
  const endPointURL = `${apiURL}${apiLevel}/users/settings/`;
  const { response } = await fetchData(endPointURL, 'get');
  const mappedObject = {};
  for (const { option, value } of response.options) {
    mappedObject[option] = value;
  }
  return mappedObject;
};

export default {
  setUserSettings,
  fetchUserSettings,
  fetchAbTestOptions,
};
